import type { OrgSource } from '@carcheck/shared';
import Chip, { type ChipProps } from '@mui/material/Chip';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Where a company came from (AUT-536): «админ» — made in this panel (grey),
 * «профиль специалиста» — made from a specialist's own profile (blue). The
 * badges of `companies-list.html` / `companies-detail.html`.
 */
const COLOR: Record<OrgSource, ChipProps['color']> = {
  admin: 'default',
  self: 'info',
};

export const CompanySourceBadge = ({ source }: { source: OrgSource }): ReactElement => {
  const { t } = useTranslation();
  return <Chip size="small" color={COLOR[source]} label={t(`companies.source.${source}`)} />;
};
